import React, { Component } from 'react';
import ModalCuotas from './../Servicios/ModalCuotas.js';
import ModalQRCuotaScanner from '../../../components/Pagar/ModalQRCuotaScanner/ModalQRCuotaScanner.js';
import { Context } from '../../../components/Pagar/constants.js';

/**
 * ModalQRServicioCuotaScanner
 *
 * Setup inicial para ModalQRCuotasScanner, es para especificar que se paga
 * la cuota de un servicio.
 */
class ModalQRServicioCuotaScanner extends Component {
    render() {
        return (
            <ModalQRCuotaScanner
                // Es necesarios pasar los this.props (props del componente 
                // padre) para que se actualize el ParadigmaTable.
                {...this.props}
                ModalCuotasProp = {ModalCuotas}
                context={Context.SERVICIO}
                cuotaIdPropName={"id"}
                contextIdPropName={"idServicio"}
                title={"Escanear QR para cobro de cuota de un servicio"}
            />
        );
    }
}

export default ModalQRServicioCuotaScanner;



// WEBPACK FOOTER //
// ./src/views/Servicios/Cobros/ModalQRServicioCuotaScanner.js